import { render, staticRenderFns } from "./SaisieAbsenceGame.vue?vue&type=template&id=373968df&"
import script from "./SaisieAbsenceGame.vue?vue&type=script&lang=js&"
export * from "./SaisieAbsenceGame.vue?vue&type=script&lang=js&"
import style0 from "./SaisieAbsenceGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports